import firebase from "firebase";
import firestore from "../../../firebase/firestore";
import { getCoupon } from "../../../services/coupon";

import moment from "moment";
export default {
  resetFilter({ commit }) {
    commit("resetState");
  },
  async getSalesByParams({ commit }, params) {
    let sales = [];
    let salesTotal = 0;
    let salesPaid = 0;
    let salesDesqualify = 0;
    let salesDesqualifyDeb = 0;
    try {
      commit("setLoading", true);
      commit("setSales", []);
      if (params) {
        let userRef = firestore.collection("users");
        if (params.email_seller) {
          userRef = userRef.where(
            "signedcontract_partner",
            "==",
            params.email_seller,
          );
        }
        // } else {
        //     alert('Erro: Vendendor não identificado!')
        //     return
        // }
        if (params.email) {
          userRef = userRef.where("email", "==", params.email);
        } else if (params.cpf) {
          userRef = userRef.where("cpf", "==", params.cpf);
        } else if (params.status && params.status !== "") {
          if (params.status !== "not_payment") {
            userRef = userRef.where("status", "==", params.status);
          }
          if (params.dt_inicial)
            userRef = userRef.where(
              "signedcontract_at",
              ">=",
              params.dt_inicial + "T00:00:00",
            );
          if (params.dt_final)
            userRef = userRef = userRef.where(
              "signedcontract_at",
              "<=",
              params.dt_final + "T23:59:59",
            );
        } else if (params.dt_inicial) {
          userRef = userRef.where(
            "signedcontract_at",
            ">=",
            params.dt_inicial + "T00:00:00",
          );
          if (params.dt_final)
            userRef = userRef = userRef.where(
              "signedcontract_at",
              "<=",
              params.dt_final + "T23:59:59",
            );
        }
        userRef = userRef.orderBy("signedcontract_at", "desc");

        userRef.onSnapshot(async (res) => {
          const changes = res.docChanges();
          // eslint-disable-next-line no-unused-vars
          for (const [idx, change] of changes.entries()) {
            const { newIndex, oldIndex, doc, type } = change;
            if (change.type === "added") {
              let saleRef = firestore
                .collection("sales_management")
                .where("customer_id", "==", doc.id);
              if (params.status && params.status === "not_payment") {
                saleRef = saleRef.where("payment_competence", "==", false);
              }
              const sales_management = await saleRef.get();
              // eslint-disable-next-line no-unused-vars
              for (const [i, sale] of sales_management.docs.entries()) {
                salesTotal = salesTotal + 1;
                let new_doc = {
                  uc: sale.data().consumer_unit || "não informada",
                  ...doc.data(),
                  id: doc.id,
                  sale: {
                    id: sale.id,
                    ...sale.data(),
                  },
                };
                if (sale.data().payment_competence)
                  salesPaid = (await salesPaid) + 1;
                if (sale.data().status === "DESQUALIFICAR")
                  salesDesqualify = (await salesDesqualify) + 1;
                //Conta Desqualificado por débito
                if (
                  sale.data().status === "DESQUALIFICAR" &&
                  sale.data().reason_desqualify.indexOf("débitos") > 0
                )
                  salesDesqualifyDeb = (await salesDesqualifyDeb) + 1;
                commit("spliceSales", {
                  index: newIndex,
                  qtde: 0,
                  data: new_doc,
                });
                // await sales.splice(newIndex, 0, new_doc)
              }
            } else if (change.type === "modified") {
              // remove the old one first
              sales.splice(oldIndex, 1);
              // if we want to handle references we would have to unsubscribe
              // from old references' listeners and subscribe to the new ones
              let saleRef = firestore
                .collection("sales_management")
                .where("customer_id", "==", doc.id);
              if (params.status && params.status === "not_payment") {
                saleRef = saleRef.where("payment_competence", "==", false);
              }
              const sales_management = await saleRef.get();
              // eslint-disable-next-line no-unused-vars
              for (const [i, sale] of sales_management.docs.entries()) {
                salesTotal = salesTotal + 1;
                let new_doc = {
                  uc: sale.data().consumer_unit || "não informada",
                  ...doc.data(),
                  id: doc.id,
                  sale: {
                    id: sale.id,
                    ...sale.data(),
                  },
                };
                if (sale.data().payment_competence) salesPaid = salesPaid + 1;
                if (sale.data().status === "DESQUALIFICAR")
                  salesDesqualify = salesDesqualify + 1;
                //Conta Desqualificado por débito
                if (
                  sale.data().status === "DESQUALIFICAR" &&
                  sale.data().reason_desqualify.indexOf("débitos") > 0
                )
                  salesDesqualifyDeb = (await salesDesqualifyDeb) + 1;
                commit("spliceSales", {
                  index: newIndex,
                  qtde: 1,
                  data: new_doc,
                });
                // await sales.splice(newIndex, 0, new_doc)
              }
            } else if (type === "removed") {
              salesTotal = salesTotal - 1;
              // if(sale.data().payment_competence) salesPaid = salesPaid + 1
              commit("spliceSales", { index: oldIndex, qtde: 1 });
              // sales.splice(oldIndex, 1)
              // if we want to handle references we need to unsubscribe
              // from old references
            }
          }
          // commit('setSales', sales)
          commit("setSalesTotal", salesTotal);
          commit("setSalesPaid", salesPaid);
          commit("setSalesDesqualify", salesDesqualify);
          commit("setsalesDesqualifyDeb", salesDesqualifyDeb);
          commit("setLoading", false);
        });
      }
    } catch (err) {
      commit("setSales", []);
      commit("setSalesTotal", salesTotal);
      commit("setSalesPaid", salesPaid);
      commit("setsalesDesqualifyDeb", salesDesqualifyDeb);
      commit("setLoading", false);
      console.error(err);
    }
  },
  async getSalesDay({ state, commit }) {
    let date = moment(new Date()).format("YYYY-MM-DD");
    try {
      commit("setSalesDay", []);
      let userRef = firestore.collection("users");
      userRef = userRef.where("signedcontract_at", ">=", date + "T00:00:00");
      userRef = userRef = userRef.where(
        "signedcontract_at",
        "<=",
        date + "T23:59:59",
      );
      userRef = userRef.orderBy("signedcontract_at", "desc");

      userRef.onSnapshot(async (res) => {
        if (res.size > 0) {
          const changes = res.docChanges();
          changes.forEach(async (change) => {
            const { doc } = change;
            switch (change.type) {
              case "added": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                await commit("pushSalesDay", data);
                break;
              }
              case "modified": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                const index = state.salesDay.findIndex((i) => i.id === doc.id);
                await commit("spliceSalesDay", { index, data });
                break;
              }
              case "removed": {
                let new_sales_day = state.salesDay.filter(
                  (i) => i.id !== doc.id,
                );
                await commit("setSalesDay", new_sales_day);
                break;
              }
              default:
                break;
            }
          });
          await commit("setLoading", false);
          return true;
        } else {
          await commit("setSalesDay", []);
        }
      });
    } catch (err) {
      await commit("setLoading", false);
      await commit("setSalesDay", []);
      console.error(err);
    }
  },

  async getUsersBySeller({ state, commit }, params) {
    commit("setLoading", true);
    let userRef = firestore.collection("users");
    let ucsRef = firestore.collection("consumer_units");
    let qualifications = state.sales.qualifications?.map((el) => el) || [];
    let contracts = state.sales.contracts?.map((el) => el) || [];
    let active = state.sales.active?.map((el) => el) || [];
    let canceled = state.sales.canceled?.map((el) => el) || [];
    let disqualified = state.sales.disqualified?.map((el) => el) || [];
    let sales = [];
    let contractsNotSign = state.sales.contractsNotSign?.map((el) => el) || [];
    await userRef
      .where("signedcontract_partner", "==", params.email)
      .where("signedcontract_at", ">=", params.start_date)
      .where("signedcontract_at", "<=", params.end_date)
      .orderBy("signedcontract_at", "desc")
      .onSnapshot(async (res) => {
        const changes = await res.docChanges();
        // eslint-disable-next-line no-unused-vars
        for (const [idx, change] of changes.entries()) {
          const { newIndex, oldIndex, doc, type } = change;
          if (change.type === "added") {
            let new_doc = {
              id: doc.id,
              ...doc.data(),
            };

            // eslint-disable-next-line no-unused-vars

            if (
              doc.data().status === "QUALIFICAR" ||
              doc.data().status === "AGUARDANDO_CONTA" ||
              doc.data().status === "AGUARDANDO_NRO_INSTALACAO" ||
              doc.data().status === "MULTIPLAS_CONTAS" ||
              doc.data().status === "NOT_HOLDER" ||
              doc.data().status === "PAYMENT_METHOD_NOT_SELECTED" ||
              doc.data().status === "QUALIFICAR_MANUALMENTE" ||
              doc.data().status === "SEM_RETORNO" ||
              doc.data().status === "WAIT_ADD_CREDIT_CARD"
            ) {
              qualifications.push(new_doc);
            } else if (doc.data().status === "DESQUALIFICAR") {
              disqualified.push(new_doc);
            } else if (doc.data().status === "ATIVO") {
              let ucs = await ucsRef.where("user_id", "==", doc.id).get();
              if (ucs.size <= 0) active.push(new_doc);
              for (let i = 0; i < ucs.size; i++) {
                let uc = { id: ucs.docs[i].id, ...ucs.docs[i].data() };
                const doc_uc = {
                  ...new_doc,
                  uc: uc,
                };
                if (
                  uc.status === "awaiting_signature" ||
                  uc.status === "awaiting_contract_generation"
                )
                  await contracts.push(doc_uc);
                else if (uc.status === "canceled" || uc.status === "canceling")
                  await canceled.push(doc_uc);
                else if (uc.status === "contract_not_signed")
                  await contractsNotSign.push(doc_uc);
                else if (uc.status === "activated") await active.push(doc_uc);
              }
            } else if (
              doc.data().status === "CANCELED" ||
              doc.data().status === "canceled" ||
              doc.data().status === "INATIVO" ||
              doc.data().status === "CANCELING" ||
              doc.data().status === "canceling"
            ) {
              canceled.push(new_doc);
            }
            sales.push(new_doc);
          } else if (change.type === "modified") {
            let new_doc = {
              id: doc.id,
              ...doc.data(),
            };
            // eslint-disable-next-line no-unused-vars
            sales.splice(oldIndex, 1);
            sales.splice(newIndex, 0, new_doc);
            if (
              doc.data().status === "QUALIFICAR" ||
              doc.data().status === "AGUARDANDO_CONTA" ||
              doc.data().status === "AGUARDANDO_NRO_INSTALACAO" ||
              doc.data().status === "MULTIPLAS_CONTAS" ||
              doc.data().status === "NOT_HOLDER" ||
              doc.data().status === "PAYMENT_METHOD_NOT_SELECTED" ||
              doc.data().status === "QUALIFICAR_MANUALMENTE" ||
              doc.data().status === "SEM_RETORNO" ||
              doc.data().status === "WAIT_ADD_CREDIT_CARD"
            ) {
              qualifications.splice(oldIndex, 1);
              qualifications.splice(newIndex, 0, new_doc);
            } else if (doc.data().status === "DESQUALIFICAR") {
              disqualified.splice(oldIndex, 1);
              disqualified.splice(newIndex, 0, new_doc);
            } else if (doc.data().status === "ATIVO") {
              let ucs = await ucsRef.where("user_id", "==", doc.id).get();
              if (ucs.size <= 0) active.push(new_doc);
              for (let i = 0; i < ucs.size; i++) {
                let uc = { id: ucs.docs[i].id, ...ucs.docs[i].data() };
                const doc_uc = {
                  ...new_doc,
                  uc: uc,
                };
                if (uc.status === "awaiting_signature") {
                  contracts.splice(oldIndex, 1);
                  contracts.splice(newIndex, 0, doc_uc);
                } else if (
                  uc.status === "canceled" ||
                  uc.status === "canceling"
                ) {
                  canceled.splice(oldIndex, 1);
                  canceled.splice(newIndex, 0, doc_uc);
                } else if (uc.status === "activated") {
                  active.splice(oldIndex, 1);
                  active.splice(newIndex, 0, doc_uc);
                } else if (uc.status === "contract_not_signed") {
                  contractsNotSign.splice(oldIndex, 1);
                  contractsNotSign.splice(newIndex, 0, doc_uc);
                }
              }
            } else if (
              doc.data().status === "CANCELED" ||
              doc.data().status === "canceled" ||
              doc.data().status === "INATIVO" ||
              doc.data().status === "CANCELING" ||
              doc.data().status === "canceling"
            ) {
              canceled.splice(oldIndex, 1);
              canceled.splice(newIndex, 0, new_doc);
            }
          } else if (type === "removed") {
            sales.splice(oldIndex, 1);
            if (
              doc.data().status === "QUALIFICAR" ||
              doc.data().status === "AGUARDANDO_CONTA" ||
              doc.data().status === "AGUARDANDO_NRO_INSTALACAO" ||
              doc.data().status === "MULTIPLAS_CONTAS" ||
              doc.data().status === "NOT_HOLDER" ||
              doc.data().status === "PAYMENT_METHOD_NOT_SELECTED" ||
              doc.data().status === "QUALIFICAR_MANUALMENTE" ||
              doc.data().status === "SEM_RETORNO" ||
              doc.data().status === "WAIT_ADD_CREDIT_CARD"
            ) {
              qualifications.splice(oldIndex, 1);
            } else if (doc.data().status === "DESQUALIFICAR") {
              disqualified.splice(oldIndex, 1);
            } else if (doc.data().status === "ATIVO") {
              let ucs = await ucsRef.where("user_id", "==", doc.id).get();
              for (let i = 0; i < ucs.size; i++) {
                let uc = { id: ucs.docs[i], ...ucs.docs[i].data() };
                if (uc.status === "awaiting_signature") {
                  contracts.splice(oldIndex, 1);
                } else if (
                  uc.status === "canceled" ||
                  uc.status === "canceling"
                ) {
                  canceled.splice(oldIndex, 1);
                } else if (uc.status === "activated") {
                  active.splice(oldIndex, 1);
                } else if (uc.status === "contract_not_signed") {
                  contractsNotSign.splice(oldIndex, 1);
                }
              }
            } else if (
              doc.data().status === "CANCELED" ||
              doc.data().status === "canceled" ||
              doc.data().status === "INATIVO" ||
              doc.data().status === "CANCELING" ||
              doc.data().status === "canceling"
            ) {
              canceled.splice(oldIndex, 1);
            }
          }
          if (idx >= changes.length - 1) {
            await commit("setSales", sales);
            await commit("setQualifications", qualifications);
            await commit("setContracts", contracts);
            await commit("setContractsNotSign", contractsNotSign);
            await commit("setDisqualified", disqualified);
            await commit("setActive", active);
            await commit("setCanceled", canceled);
            await commit("setLoading", false);
          }
        }
        if (changes.length <= 0) {
          commit("setLoading", false);
          return;
        }
      });
  },
  getLeadsBySeller({ commit }, params) {
    commit("setLoadingLeadsBySeller", true);
    commit("setSubscriptions", []);
    // let leads = state.sales.leads || []
    let leadsRef = firestore.collection("leads");
    leadsRef = leadsRef.where("saved_partner", "==", params.email);
    // .where('finished', '==', false)
    // .where('status', '==', 'SAVED')

    if (params.start_date)
      leadsRef = leadsRef.where(
        "saved_at",
        ">=",
        firebase.firestore.Timestamp.fromDate(new Date(params.start_date)),
      );
    if (params.end_date)
      leadsRef = leadsRef.where(
        "saved_at",
        "<=",
        firebase.firestore.Timestamp.fromDate(new Date(params.end_date)),
      );

    leadsRef
      .orderBy("saved_at", "desc")
      // .orderBy('saved_at','desc')
      // .limit(10)
      .onSnapshot(async (res) => {
        let changes = res.docChanges();
        changes = changes.filter((change) => {
          return (
            !change.doc.data().finished &&
            !change.doc.data().status.includes("ARQUIVADO")
          );
        });
        if (changes.length <= 0) {
          commit("setLoadingLeadsBySeller", false);
          return;
        }
        // eslint-disable-next-line no-unused-vars
        for (const [idx, change] of changes.entries()) {
          const { newIndex, oldIndex, doc, type } = change;
          if (change.type === "added") {
            let new_doc = {
              ...doc.data(),
              id: doc.id,
            };
            // leads.splice(newIndex, 0, new_doc)
            commit("pushSubscriptions", new_doc);
          } else if (change.type === "modified") {
            // remove the old one first
            // leads.splice(oldIndex, 1)
            // if we want to handle references we would have to unsubscribe
            // from old references' listeners and subscribe to the new ones
            if (doc.data().status !== "SAVED") {
              let new_doc = {
                ...doc.data(),
                id: doc.id,
              };
              commit("spliceSubscriptions", {
                index: newIndex,
                qtde: 1,
                data: new_doc,
              });
              // leads.splice(newIndex, 0, new_doc)
            }
          } else if (type === "removed") {
            commit("spliceSubscriptions", { index: oldIndex, qtde: 1 });
            // leads.splice(oldIndex, 1)
          }
          if (idx >= changes.length - 1) {
            await commit("setLoadingLeadsBySeller", false);
          }
        }
      });
  },
  getLeads({ state, commit }) {
    commit("setLoadingLeads", true);
    try {
      let leads = state.sales.leads || [];
      let leadsRef = firestore.collection("leads");
      // leadsRef = leadsRef
      //     .where('inqueue', '==', true)
      // .where('status', '==', 'SAVED')
      leadsRef = leadsRef.where("tabulation", "==", "towork");
      // if(params && params.start_date)
      //     // leadsRef = leadsRef.where('updated_at', '>=', new Date(params.start_date))
      // if(params && params.end_date)
      //     // leadsRef = leadsRef.where('updated_at', '<=', new Date(params.end_date))

      leadsRef = leadsRef.limit(20);
      leadsRef
        .orderBy("updated_at", "desc")
        // .orderBy('saved_at','desc')
        // .limit(10)
        .onSnapshot(async (res) => {
          const changes = res.docChanges();
          if (changes.length <= 0) {
            commit("setLoadingLeads", false);
            return;
          }
          // eslint-disable-next-line no-unused-vars
          for (const [idx, change] of changes.entries()) {
            const { newIndex, oldIndex, doc, type } = change;
            if (change.type === "added") {
              let new_doc = {
                ...doc.data(),
                id: doc.id,
              };
              commit("spliceLeads", {
                index: newIndex,
                qtde: 0,
                data: new_doc,
              });
              // leads.splice(newIndex, 0, new_doc)
            } else if (change.type === "modified") {
              // remove the old one first
              leads.splice(oldIndex, 1);
              // if we want to handle references we would have to unsubscribe
              // from old references' listeners and subscribe to the new ones
              if (doc.data().status !== "SAVED") {
                let new_doc = {
                  ...doc.data(),
                  id: doc.id,
                };
                commit("spliceLeads", {
                  index: newIndex,
                  qtde: 1,
                  data: new_doc,
                });
                // leads.splice(newIndex, 0, new_doc)
              }
            } else if (type === "removed") {
              commit("spliceLeads", { index: oldIndex, qtde: 1 });
              // leads.splice(oldIndex, 1)
            }
            if (idx >= changes.length - 1) {
              await commit("setLoadingLeads", false);
            }
          }
        });
    } catch (err) {
      console.error(err);
      commit("setLoadingLeads", false);
    }
  },
  getCoupons({ commit }, coupon) {
    let today = new Date().toISOString().substring(0, 10);
    commit("setCoupon", null);
    if (!coupon || coupon.trim() === "") return;
    return getCoupon(coupon)
      .then((res) => {
        if (!res || res.size <= 0)
          return {
            status: false,
            message: "Cupom não encontrado ou expirado!",
          };
        let coupon = {
          id: res.docs[0].id,
          ...res.docs[0].data(),
        };
        // Verifica se o limite do cupom já foi atingido
        if (coupon.limit && coupon.limit > 0 && coupon.used >= coupon.limit)
          return { status: false, message: "Cupom excedeu o limite de uso!" };
        // Verifica se a data de inicio do cupom é menor ou igual a hoje
        if (coupon.start_at > today)
          return { status: false, message: "Cupom ainda não está ativo" };

        // //validação para permitir usar cupom CORREIOS100 apenas com número de matrícula
        // if(coupon.coupon === "CORREIOS100") {
        //   commit("setCoupon", coupon)
        //   return { status: res.size > 0, message: "Ok", origin: coupon.coupon }
        // }

        commit("setCoupon", coupon);
        return { status: res.size > 0, message: "Ok" };
      })
      .catch((err) => {
        console.error(err);
        return { status: false, message: "Erro ao buscar o cupom" };
      });
  },
  async getPlansByParams({ commit }, params) {
    try {
      commit("setLoading", true);
      commit("setPlans", []);
      let plansRef = firestore.collection("plans");
      plansRef = plansRef.where("person_type", "==", params.person_type);
      if (params.utility_company)
        plansRef = plansRef.where(
          "utility_company",
          "==",
          params.utility_company,
        );
      if (params.company)
        plansRef = plansRef.where("company", "==", params.company);
      if (params.plan_id) {
        plansRef = plansRef.where("id", "==", params.plan_id);
      } else {
        plansRef = plansRef.where("status", "==", "activated");
      }
      return plansRef
        .get()
        .then((plans) => {
          if (plans.size > 0) {
            for (let i = 0; i < plans.size; i++) {
              let doc = { id: plans.docs[i].id, ...plans.docs[i].data() };
              if (!doc.allow_correios) continue;
              commit("pushPlan", doc);
            }
            commit("setLoading", false);
          } else {
            commit("setPlans", []);
            commit("setLoading", false);
          }
        })
        .catch((err) => {
          console.error(err);
          commit("setPlans", []);
          commit("setLoading", false);
        });
    } catch (err) {
      await commit("setLoading", false);
      await commit("setPlans`", []);
      console.error(err);
    }
  },
  async getAllPlans({ state, commit }) {
    try {
      commit("setLoading", true);
      commit("setPlans", []);
      let plansRef = firestore.collection("plans");
      return plansRef
        .get()
        .then((plans) => {
          if (plans.size > 0) {
            for (let i = 0; i < plans.size; i++) {
              let doc = { id: plans.docs[i].id, ...plans.docs[i].data() };
              if (!state.plans.find((obj) => obj.id == doc.id)) {
                commit("pushPlan", doc);
              }
            }
            commit("setLoading", false);
          } else {
            commit("setPlans", []);
            commit("setLoading", false);
          }
        })
        .catch((err) => {
          console.error(err);
          commit("setPlans", []);
          commit("setLoading", false);
        });
    } catch (err) {
      await commit("setLoading", false);
      await commit("setPlans`", []);
      console.error(err);
    }
  },
  async getTabulations({ commit }) {
    commit("setTabulations", []);
    try {
      commit("setLoading", true);
      let tabulationsRef = firestore.collection("tabulations");
      tabulationsRef = tabulationsRef.where("status", "==", "activated");
      return await tabulationsRef
        .get()
        .then((tabulations) => {
          if (tabulations.size > 0) {
            for (let i = 0; i < tabulations.size; i++) {
              let doc = {
                id: tabulations.docs[i].id,
                ...tabulations.docs[i].data(),
              };
              commit("pushTabulations", doc);
            }
            commit("setLoading", false);
          } else {
            commit("setTabulations", []);
            commit("setLoading", false);
          }
        })
        .catch((err) => {
          console.error(err);
          commit("setTabulations", []);
          commit("setLoading", false);
        });
    } catch (err) {
      await commit("setLoading", false);
      await commit("setTabulations`", []);
      console.error(err);
    }
  },
  async getMember({ commit }, params) {
    if (params.type === "email") {
      let lead = await firestore.collection("leads").doc(params.value).get();
      let user = await firestore
        .collection("users")
        .where("email", "==", params.value)
        .get();
      if (user.empty) {
        if (!lead.exists) return null;
        let new_lead = { id: lead.id, ...lead.data() };
        if (!new_lead?.signedcontract_by) new_lead.signedcontract_by = null;
        if (!new_lead?.enercred_contract) new_lead.enercred_contract = true;

        new_lead.utility_company =
          new_lead?.utility_company ||
          new_lead?.utility ||
          new_lead?.concessionaria;

        commit("setLead", new_lead);
        commit("setUser", new_lead);
        return new_lead;
      } else {
        let new_user = { id: user.docs[0].id, ...user.docs[0].data() };
        let new_lead = { id: lead.id, ...lead.data(), user: new_user };

        new_user.utility_company =
          new_user?.utility_company ||
          new_user?.utility ||
          new_user?.concessionaria;
        new_lead.utility_company =
          new_lead?.utility_company ||
          new_lead?.utility ||
          new_lead?.concessionaria;

        if (!new_user?.signedcontract_by) new_user.signedcontract_by = null;
        if (!new_user?.enercred_contract) new_user.enercred_contract = true;

        commit("setLead", new_lead);
        commit("setUser", new_user);
        return new_user;
      }
    } else if (params.type === "cpf") {
      let user = await firestore
        .collection("users")
        .where("cpf", "==", params.value)
        .get();
      if (user.empty) {
        let lead = await firestore
          .collection("leads")
          .where("cpf", "==", params.value)
          .limit(1)
          .get();
        if (lead.size <= 0) return null;
        let new_lead = { id: lead.docs[0].id, ...lead.docs[0].data() };
        if (!new_lead?.signedcontract_by) new_lead.signedcontract_by = null;
        if (!new_lead?.enercred_contract) new_lead.enercred_contract = true;

        new_lead.utility_company =
          new_lead?.utility_company ||
          new_lead?.utility ||
          new_lead?.concessionaria;

        commit("setLead", new_lead);
        commit("setUser", new_lead);
        return new_lead;
      } else {
        let new_user = { id: user.docs[0].id, ...user.docs[0].data() };
        let new_lead = {
          id: new_user.email,
          ...user.docs[0].data(),
          user: new_user,
        };

        new_user.utility_company =
          new_user?.utility_company ||
          new_user?.utility ||
          new_user?.concessionaria;
        new_lead.utility_company =
          new_lead?.utility_company ||
          new_lead?.utility ||
          new_lead?.concessionaria;

        if (!new_user?.signedcontract_by) new_user.signedcontract_by = null;
        if (!new_user?.enercred_contract) new_user.enercred_contract = true;

        commit("setLead", new_lead);
        commit("setUser", new_user);
        return new_user;
      }
    } else {
      return null;
    }
  },
  setUser({ commit }, user) {
    commit("setUser", user);
  },
  setQualificationsForm({ commit }, qualifications_form) {
    commit("setQualificationsForm", qualifications_form);
  },

  getLeadByEmail({ commit }, email) {
    commit("setLoading", true);
    if (email) {
      let lead = {};
      return firestore
        .collection("leads")
        .doc(email)
        .onSnapshot((res) => {
          if (res.exists) {
            lead = {
              id: res.id,
              ...res.data(),
            };
            commit("setLead", lead);
          } else {
            commit("setLead", null);
          }
          commit("setLoading", false);
        });
    } else {
      commit("setLead", null);
    }
    commit("setLoading", false);
  },
  async getSubClassByUtility({ state, commit }, utility) {
    try {
      commit("setLoading", true);
      commit("setSubClasses", []);
      let subClassesRef = firestore
        .collection("utility_companies")
        .doc(utility)
        .collection("electricity_tariff")
        .orderBy("order", "asc");
      return subClassesRef
        .get()
        .then((subClasses) => {
          if (subClasses.size > 0) {
            for (let i = 0; i < subClasses.size; i++) {
              let doc = {
                id: subClasses.docs[i].id,
                ...subClasses.docs[i].data(),
              };
              if (!state.subclasses.find((obj) => obj.id == doc.id)) {
                commit("pushSubClass", doc);
              }
            }
            commit("setLoading", false);
          } else {
            commit("setSubClasses", []);
            commit("setLoading", false);
          }
        })
        .catch((err) => {
          console.error(err);
          commit("setSubClasses", []);
          commit("setLoading", false);
        });
    } catch (err) {
      await commit("setLoading", false);
      await commit("setSubClasses", []);
      console.error(err);
    }
  },
  async getSellers({ commit }) {
    commit("setSellers", []);
    try {
      let userRef = await firestore
        .collection("users")
        .where("group", "array-contains-any", [
          "sales_partner",
          "sales_management",
          "sales_partner_management",
        ])
        .get();
      let users = userRef.docs?.map((item) => item?.data());
      let activeUsers = users?.filter((item) => item.status == "ATIVO");
      commit("setSellers", activeUsers);
    } catch (error) {
      console.log(error);
      throw new Error(error);
    }
  },
};
